export const MOBILE = 'MOBILE';
export const DESKTOP = 'DESKTOP';
export const COMPLETED = 'COMPLETED';
export const IDENTIFICATION_COMPLETED = 'IDENTIFICATION_COMPLETED';
export const EXPIRED = 'EXPIRED';
